export class Messages {
    public static LEASING_COMPONENT = {
        location: {
            required: 'Valitse paikkakunta.'
        },
        monthlyFee: {
            required: 'Valitse kuukausimaksu.'
        },
        contractLength: {
            required: 'Valitse sopimuksen pituus.'
        },
        contractMileage: {
            required: 'Valitse ajokilometrit.'
        },
        make: {
            required: 'Valitse merkki.'
        },
        model: {
            required: 'Valitse malli.'
        },
        bodyType: {
            required: 'Valitse korimalli.'
        },
        fuelType: {
            required: 'Valitse käyttövoima.'
        },
        additionalInformation: {
			maxlength: 'Leasing auton lisätietokentän maksimi pituus on 500 merkkiä.'
		},
        contactPerson: {
            ownCar: {
                registrationNumber: {
                    required: 'Anna rekisterinumero.'
                },
                mileage: {
                    required: 'Anna ajokilometrit.',
                    pattern: 'Ajokilometreissä saa olla vain numeroita.'
                },
                additionalInformation: {
					maxlength: 'Auton lisätietokentän maksimi pituus on 2000 merkkiä.'
				}
            },
            name: {
                required: 'Anna nimesi.'
            },
            emailAddress: {
                required: 'Anna sähköpostiosoitteesi.',
                email: 'Sähköpostiosoite on virheellinen.',
            },
            phoneNumber: {
                required: 'Anna puhelinnumerosi.',
                pattern: 'Puhelinnumero on virheellinen.'
            },
            contactMethod: {
                requires: 'Valitse yhteydenottotapa.'
            }
        },
        general: {
            success: {
                title: 'Kiitos, lomake lähetettiin onnistuneesti.',
                message: 'Toimitamme tarjouspyyntösi seuraaville palveluntarjoajille: '
            },
            error: {
                title: 'Hupsista!',
                message: 'Tapahtui virhe. Yritä hetken kuluttua uudestaan.'
            },
            invalidForm: 'Lomaketta ei ole täytetty oikein. Tarkista tiedot.'
        }
    }
}
